import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  Table,
  TableContainer,
  Paper,
} from "@material-ui/core";
import { facturasApi } from "src/services/facturasApi";

export default function DetalleFacturaCliente(props) {
  const { open, setOpen, factura } = props;

  const { data: detalleFactura = [] } =
    facturasApi.useGetDetalleFacturaPlanesQuery(factura.id);

  const handleClose = () => {
    setOpen(false);
  };

  function formatNumber(n) {
    n = n > 0 ? String(n).replace(/\D/g, "") : n;

    return n === "" ? n : Number(n).toLocaleString("es-CL");
  }

  return (
    <Dialog open={open} fullWidth maxWidth="md">
      <DialogTitle>Detalle Factura</DialogTitle>
      <DialogContent>
        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Nombre Plan</TableCell>
                <TableCell>Valor Plan</TableCell>
                <TableCell>Empleado</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {detalleFactura &&
                detalleFactura.map((row, index) => (
                  <TableRow key={"tablaDetallePlan_" + index}>
                    <TableCell>{row.nombrePlan}</TableCell>
                    <TableCell>{formatNumber(row.valorPlan)}</TableCell>
                    <TableCell>
                      {row.nombreEmpleado + " " + row.apellidoEmpleado}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cerrar</Button>
      </DialogActions>
    </Dialog>
  );
}
